import MediaLibrary from "../upload/MediaLibrary";
import UploadService from "../upload/UploadService";
import {_} from "../util/dom";
import Dropbox from './Dropbox';
import UploadList from "./UploadList";
import MediaSelectableList from './MediaSelectableList';


class UploadModal {
    constructor() {
        this.selectedFiles = []; // will contain a list of keys for the media library images
        this.modal = $('#upload-modal');
        this.organizationId = parseInt(_('meta[name="current-organization"').content);

        this.onMediaChange = this.onMediaChange.bind(this);
        this.updateEvidence = this.updateEvidence.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        
        // service comes after the binds as it relies on the events 
        // to be bound to this class
        this.service = this.setupUploadService();

        this.modal.find('.modal-done').click(this.updateEvidence);
    }

    setupUploadService() {
        const dropbox = this.modal.find('.dropbox');
        const uploadList = this.modal.find('.new-files');
        const mediaList = this.modal.find('.existing-files tbody');

        return new UploadService()
            .registerDropbox(new Dropbox(dropbox))
            .registerUploadList(new UploadList(uploadList))
            .registerMediaList(new MediaSelectableList(mediaList, this.onMediaChange))
            .on('success', this.handleUpload)
    }

    reset() {
        this.selectedFiles = [];
    }

    openFileDialog(uploader) {
        this.lastUploader = uploader;
        this.reset();

        this.selectedFiles = this.lastUploader.existingFiles;
        this.service.mediaList.selectFiles(this.selectedFiles);

        this.modal.modal('open');
    }

    onMediaChange(evt) {
        const target = evt.currentTarget;
        const key = target.getAttribute('data-key');
        const file = MediaLibrary.get(key);

        if(file.checkbox.input.checked) {
            const selectedIndex = this.selectedFiles.findIndex(file => file.key === key);
            this.selectedFiles.splice(selectedIndex, 1);
        }
        else {
            this.selectedFiles.push(file);
        }
    }

    updateEvidence(evt) {
        const keys = this.selectedFiles.map(file => file.key);
        this.linkMediaRequest(keys, this.lastUploader.questionId, () => {
            this.lastUploader.changeExistingFiles(this.selectedFiles);
            this.modal.modal('close');
        });
    }

    handleUpload(fileKey) {
        const file = MediaLibrary.get(fileKey);
        this.selectedFiles.push({ key: file.key, name: file.name });
    }

    linkMediaRequest(keys, questionId, callback) {
        $.ajax({

            url: "/api/media-link",
            method: "POST",
            data: {
                report_id: $('#report-id').val(),
                question_id: questionId,
                organizationId: this.organizationId,
                media_keys: keys,
                _token: $('meta[name=csrf-token]').attr('content'),
            },

            success: callback,

        });
    }

    getService() {
        return this.service;
    }
};


export default UploadModal;